import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { terminateCards } from '../api/simActionsApi';

export const useTerminateMutation = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return terminateCards(props);
    },
  });
};
